import {
  renderMainLeftCell,
  renderSectionHeader,
  renderRowGaps
} from '../helpers';

import { textBold } from '../download-data-styles';

const underlyingHoldingsModule = allocations => {
  let moduleString = ``;
  moduleString += renderSectionHeader('Underlying Funds');
  allocations.forEach(allocation => {
    moduleString += `<tr>${renderMainLeftCell(allocation.objective, textBold)}</tr>`;
    allocation.funds.forEach(fund => {
      moduleString += `<tr>${renderMainLeftCell(fund.UnderlyingFundName)}</tr>`;
    });
    moduleString += renderRowGaps();
  });
  moduleString += renderRowGaps(2);
  return moduleString;
};

export default underlyingHoldingsModule;
